// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fa-icon[data-v-2da5bf9d] {\n  vertical-align: middle;\n  margin-right: 5px;\n}\n.big-add[data-v-2da5bf9d] {\n  width: 100%;\n  line-height: 80px;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n.song_list[data-v-2da5bf9d] {\n  min-width: 300px;\n  margin: 0 20px;\n}\n", ""]);
// Exports
module.exports = exports;
